<template>
<div id="feature">
  <Vue100vh>
    <div class="w-100 h-100 bg-cover bg-center" v-prlx.mobile.background="{ speed: 0.07 }" :style="{backgroundImage: 'url('+ bgImage +')'}">
      <div class="right-title text-white">
        <h1 class="text-right">左ききの<br>シャツ</h1>
        <h5 class="h2 text-right overpass tracking-2"><small>with</small> 10YC</h5>
      </div>
    </div>
  </Vue100vh>

  <div class="py-md-4">
  </div>

  <b-container class="py-5">
    <b-form-row>
      <b-col cols="6" md="6" lg="5" offset-lg="1" class="pt-4 pt-md-5 pr-md-5 pl-4 pl-md-5 pl-lg-0">
        <div class="v-scroll-reveal">
          <img class="img-fluid" src="@/assets/images/feature-2.jpg" srcset="@/assets/images/feature-2@2x.jpg 2x">
        </div>
      </b-col>
      <b-col cols="6" md="6" lg="6" >
        <div class="pr-md-5">
          <div class="pr-4 pr-md-5">
            <div class="v-scroll-reveal">
              <img class="img-fluid" src="@/assets/images/feature-1.jpg" srcset="@/assets/images/feature-1@2x.jpg 2x">
            </div>
          </div>
        </div>
        <div class="pl-4 pl-md-5 mt-4 mt-md-5">
          <div class="v-scroll-reveal">
            <img class="img-fluid" src="@/assets/images/feature-3.jpg" srcset="@/assets/images/feature-3@2x.jpg 2x">          
          </div>
        </div>
      </b-col>
    </b-form-row>
    <b-row>
      <b-col cols="5" md="4" lg="4">
        <div class="v-scroll-reveal">
          <img class="img-fluid mt-lg--6" src="@/assets/images/feature-4.jpg" srcset="@/assets/images/feature-4@2x.jpg 2x">        
        </div>
      </b-col>
      <b-col cols="6" md="6" lg="5" offset-md="1" class="pt-5"> 
        <div class="v-scroll-reveal">
          <img class="img-fluid" src="@/assets/images/feature-5.jpg" srcset="@/assets/images/feature-5@2x.jpg 2x">
        </div>
      </b-col>
    </b-row>
  </b-container>
  <div class="py-md-4">
  </div>

</div>
</template>

<script>
import bg from '@/assets/images/bg-top.jpg'
import bg2x from '@/assets/images/bg-top@2x.jpg'
import bgXs from '@/assets/images/bg-top@xs.jpg'
import isMobile from 'ismobilejs'
import Vue100vh from 'vue-div-100vh'

export default {
  name: 'Feature',
  components: {
    Vue100vh
  },
  computed: {
    bgImage() {
      if(isMobile().phone) {
        return bgXs
      } else if (window.innerWidth > 1440) {
        return bg2x
      } else if (window.devicePixelRatio > 1) {
        return bg2x
      } else {
        return bg
      }
    }
  }
}
</script>

<style scoped lang="scss">
.right-title {
  position: absolute;
  top: 20px;
  right: 30px;
  @media screen and (min-width: 768px) {
    top: 50px;
    right: 60px;
  }
  h1 {
    line-height: 1.5;
    letter-spacing: 0.05em;
  }
}
@media screen and (min-width: 900px) {
  .mt-lg--6 {
    margin-top: -5rem;
  }  
}
</style>
